/**
 * Cart chrome panel refresh and add-to-cart
 */
(function () {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function openCart(skipRefresh) {
    if (window.LophielChrome) {
      window.LophielChrome.open('cart');
      return;
    }
    if (!skipRefresh) refreshCart();
  }

  function closeCart() {
    window.LophielChrome?.close();
  }

  function parseSection(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('[data-cart-body]');
  }

  function updateCountFrom(doc) {
    const count = doc.querySelector('[data-cart-count]')?.textContent?.trim();
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      if (count === undefined) return;
      el.textContent = count;
      const n = parseInt(count, 10);
      el.hidden = !n || n === 0;
    });
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      const n = parseInt(count, 10);
      el.hidden = !n || n === 0;
    });
  }

  async function refreshCartCount() {
    const res = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return;
    const cart = await res.json();
    updateCount(cart.item_count || 0);
  }

  async function refreshCart() {
    try {
      const res = await fetch(`${root}?sections=cart-drawer`);
      if (!res.ok) return;
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;
      const next = parseSection(html);
      if (!next) return;
      document.querySelectorAll('[data-cart-body]').forEach((body) => {
        body.innerHTML = next.innerHTML;
      });
      updateCountFrom(parseSection(html) || document);
    } catch (_) {}
  }

  async function addToCart(form) {
    const fd = new FormData(form);
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      body: fd,
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) {
      let message = 'Add failed';
      try {
        const data = await res.json();
        message = data.description || data.message || message;
      } catch (_) {}
      throw new Error(message);
    }
    return res.json();
  }

  function setAddedState(form) {
    const btn = form.querySelector('[data-product-card-add], .lophiel-product-card__add');
    if (!btn) return;
    const addLabel = btn.dataset.addedLabel || 'Added to bag';
    const addTextEl = btn.querySelector('.lophiel-product-card__add-text');
    const status = form.querySelector('[data-product-card-status]');
    if (addTextEl) addTextEl.textContent = addLabel;
    if (status) status.textContent = addLabel;
    btn.classList.remove('is-loading');
    btn.removeAttribute('aria-busy');
    btn.classList.add('is-added');
    btn.setAttribute('aria-label', addLabel);
    window.setTimeout(() => {
      btn.classList.remove('is-added');
      btn.setAttribute('aria-label', btn.dataset.defaultLabel || addLabel);
      if (addTextEl) addTextEl.textContent = btn.dataset.defaultText || 'Add to cart';
      if (status) status.textContent = '';
    }, 2600);
  }

  function setLoadingState(form, loading) {
    const btn = form.querySelector('[data-product-card-add], .lophiel-product-card__add');
    if (!btn) return;
    btn.classList.toggle('is-loading', loading);
    if (loading) {
      btn.setAttribute('aria-busy', 'true');
      const status = form.querySelector('[data-product-card-status]');
      if (status) status.textContent = '';
    } else {
      btn.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.lophiel-product-card__form');
    if (!form) return;
    e.preventDefault();
    try {
      setLoadingState(form, true);
      await addToCart(form);
      setAddedState(form);
      await refreshCartCount();
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => refreshCart());
      } else {
        window.setTimeout(() => refreshCart(), 800);
      }
    } catch (err) {
      setLoadingState(form, false);
      const btn = form.querySelector('[data-product-card-add], .lophiel-product-card__add');
      const status = form.querySelector('[data-product-card-status]');
      if (status) status.textContent = btn?.dataset.errorLabel || 'Could not add this item. Please try again.';
      console.warn('Lophiel add-to-cart failed:', err);
    }
  });

  window.LophielCart = { open: openCart, close: closeCart, refresh: refreshCart };
})();
